<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div v-show="Isblur" class="splash"></div>

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="background-color:unset;">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
                <h2 style="font-size: 1.2vw !important;width: auto;"><span> ارکان اجرایی </span> / <span> {{$route.params.name}}</span>   </h2>
                <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
              </div>
              <div class="row" v-if="$store.state.executive_element">
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">پست  سازمانی</label>
                  <v-select :options="all_organizations" dir="rtl" v-model="organ_id" label="name"
                            style="width: auto;   border-radius: .5vw">
                    <template v-slot:no-options>موردی یافت نشد</template>
                  </v-select>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">سمت   </label>
                  <select v-model="type" class="form-select" name="" id="">
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option value="رئیس کمیته">رئیس کمیته</option>
                    <option value= "نایب رئیس کمیته">نایب رئیس کمیته</option>
                    <option value="دبیر کمیته  ">دبیر کمیته</option>
                    <option value="عضو کمیته ">عضو کمیته</option>
                  </select>
                </div>

              </div>
              <div v-if="$store.state.executive_element" class="col-lg-12 mb-3 d-flex align-items-center justify-content-center">
                <button v-if="!is_update" @click.prevent="submitForm" class="btn btn-primary btn-submit-1 mt-4">افزودن</button>
                <button v-else @click.prevent="update(id_tem)" class="btn btn-primary btn-submit-1 mt-4">ویرایش</button>
                <Reset style="width: 1.3vw; height: 1.3vw; transform: translateY(0.7vw) translateX(-1vw)" @click.prevent="resetForm" v-if="is_update" />
              </div>
              <hr class="mb-2">
              <div class="d-flex justify-content-between mb-2">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;"
                       placeholder="جستجو بر اساس پست سازمانی ، سمت...">

              </div>
              <hr>
            </div>
            <div class="table-responsive mt-3">
              <div   v-show="!all_items.length">
                  ارکان اجرایی وجود ندارد
              </div>
              <div style="overflow-y: scroll; height: 50vw;" :style="filteredItems.length < 19 ? 'height: auto;' : ''">

              <table class="table table-striped" v-show="all_items.length">
                <thead>
                <tr>
                  <th style="width: 1vw;">ردیف</th>
                  <th style="width: 30vw;">پست سازمانی    </th>
                  <th style="width: 20vw;"> سمت    </th>
                  <th v-if="$store.state.executive_element" style="width: 2vw;">عملیات</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in filteredItems" :style="setcolor(item['level'])" >
                  <td scope="row">{{ index + 1 }}</td>

                  <td
                      style="text-align: right">{{ item['organization'] && item['organization']['name'] }}
                  </td>
                  <td class="text-end">
                    {{ item['type'] }}
                  </td>

                  <td v-if="$store.state.executive_element">
                    <div class="d-flex justify-content-start align-items-start">



                      <a @click.prevent="edit(item['id'], item.name,item['organization'] && item['organization'], item.type)" href="#">
                        <img
                             class="table-edit-img"
                             src="../../../../assets/img/pen.svg"
                             alt="edit"></a>
                      <a class="mx-1" @click.prevent="deleteModalMethod(item['id'])" href="#">
                        <img
                             class="table-delete-img"
                             src="../../../../assets/img/delete.svg"
                             alt="delete"></a>
                    </div>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Jobs -->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="infoModal" style="z-index: 999999999999999">
    <div>
      <p>جزئیات</p>
      <p @click="infoModal=!infoModal">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; border-radius: 1vw; width: 28vw; padding: 1vw;">

      </div>

      <button @click="infoModal=!infoModal">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  /modals-->


</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
import vSelect from "vue-select";
import login from "@/views/auth/Login.vue";
const toast = useToast();

export default {
  name: "ListOrganization",
  components: {vSelect, Reset, Sidebar, Splash},
  data() {
    return {
      id: '',
      name: '',
      addModal: false,
      Isblur: false,
      deleteModal: false,
      select_parent: false,
      select_curator: false,
      select_substitute: false,
      id_remove: '',
      editModal: false,
      infoModal: false,
      Error: false,
      is_update: false,
      id_tem: false,
      ErrorM: '',
      searchUser: '',
      all_organizations: [],
      organ_id: '',
      type: '',
      all_items: [],
      id_route: this.$route['params']['id'],


    }
  },
  methods: {


    edit(id,name,organ,type){
      this.is_update = true
      this.id_tem = id
      this.name = name
      this.organ_id = organ
      this.type = type
    },

    deleteModalMethod(id) {
      this.id = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ExecutiveElementsHabits/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
            }
            this.deleteModal = false
            this.all_items.length = 0
            toast.success(result.message)
            this.fetchAll()

          })
          .catch();
    },
    setcolor(level) {

      if (level === 0) {
        return `background: #86D1FF !important`

      }


      if (level === 1) {
        return 'background: #bce6ff !important'

      }
      if (level === 2) {
        return 'background: #d9f1ff !important'

      } else {
        return 'background: rgba(#d9f1ff, 40%) !important'
      }


    },
    submitForm() {

      setTimeout(() => {
        if (this.organ_id.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'پست سازمانی اجباری است!'
          this.loading = false

          return;
        } if (this.type.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'سمت  اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/ExecutiveElementsHabits`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'type': this.type,
            'organization_id': this.organ_id && this.organ_id.id,
            'executive_element_id': this.id_route,



          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                this.Error = true
                this.ErrorM = response['error']
                this.loading = false
                return
              }
              toast.success(response.message)

              this.Isblur = false
              this.loading = false
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()


            }).catch((err) => {
        })


      }, 1000)
    },
    update(id) {
      if (!this.organ_id.id) {
        this.Error = !this.Error;
        this.ErrorM = 'پست سازمانی اجباری است!';
        this.loading = false;
        return;
      }
      if (this.type.length === 0) {
        this.Error = !this.Error;
        this.ErrorM = 'سمت  اجباری است!';
        this.loading = false;
        return;
      }

      fetch(`${this.base_url}/update/habit/element/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.type,
          'organization_id': this.organ_id && this.organ_id.id,
        }),
      })
          .then(response => {
            if (response.redirected) {
              throw new Error('Redirected to login, check authentication.');
            }
            return response.json();
          })
          .then((response) => {
            if (response.error) {
              this.Error = true;
              this.ErrorM = response.error;
              this.loading = false;
              return;
            }
            this.is_update = false;
            this.all_items.length = 0;
            this.fetchAll();
            this.resetForm();
          })
          .catch((err) => {
            console.log(err);
            this.Error = true;
            this.ErrorM = 'An error occurred: ' + err.message;
            this.loading = false;
          });
    },

    resetForm() {
      this.name = ''
      this.is_update=false
      this.id=''
      this.id_tem=''
      this.type=''
      this.organ_id=''

    },



    fetchAll(){
      fetch(`${this.base_url}/ExecutiveElementsHabits/${this.id_route}`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },

      })
          .then(response => response.json())
          .then((response) => {
            if (response['error']) {

              return
            }
            if (response.data){
              this.all_items = [...response.data]
            }



          }).catch((err) => {
      })
    },
    fetchOrgans(){
      fetch(`${this.base_url}/organization/post/all`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },

      })
          .then(response => response.json())
          .then((response) => {
            if (response['error']) {

              return
            }
            if (response.all){
              this.all_organizations = [...response.all]
            }



          }).catch((err) => {
      })
    },






    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    // this.checkIsMother()
    this.fetchAll()
    this.fetchOrgans()
  },
  computed: {
    filteredItems() {
      return this.all_items.filter(item => {
        return (
            item['organization']&& item['organization']['name'].includes(this.searchUser) || item.type.includes(this.searchUser)
        );
      });
    },


  },
}
</script>

<style scoped>
label {
  width: 100%;
  text-align: right;
}

table {
  background-color: white !important;
}


img {
  cursor: pointer;
}

tr {
  background-color: #ffff !important;
}

</style>